// extracted by mini-css-extract-plugin
module.exports = {"container":"Jx-z","disabled":"Kx-z","remove":"Lx-z"};